import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";

export default function PrivacyPolicy() {
    
    return (
        <>
            {/* First Section */}
            <Header/>
            {/* <div className="about-us"> */}
            <div className="raj">
                {/* <div className="about-us-content"> */}
                    {/* <img src="/finalize/About Us/aboutUs_1600_400 (1).png" alt="" /> */}
                    <img src="/finalize/About Us/about_main.jpeg" alt="" />
                {/* </div> */}
            </div>

            <section className="aboutus-section">
            <div class="about-heading-passage raj_sub_head_text"><h2>Shaping Dreams, Constructing Futures:</h2><h2> Explore BrickX</h2>
            <span>At BrickX, we are more than a construction company; we are architects of opportunity. With a rich heritage and a commitment to quality, we transform visions into enduring structures that embody innovation and precision.</span></div>
            </section>



            <section className="aboutus-section">
                <div className="aboutus-section-img-view">
                    <div className="aboutus-section-img ">
                        <img src="/finalize/About Us/about_profile.jpeg" alt="" />
                    </div>
                </div>
                <div className="aboutus-section-content">
                    <h1 className="aboutus-section-heading">About BrickX</h1>
                    {/* <p className="aboutus-section-subheading">Welcome to BrickX, where your dream home becomes a reality. At BrickX, we understand that building a home is one of the most significant investments you'll ever make. That's why we are committed to being the trusted partner you can rely on throughout your journey.</p> */}
                    <p className="aboutus-section-subheading">BrickX is a building construction brand that strives to be the trusted partner for individuals and families looking to build their dream homes. It is specialized in creating quality, customizable residential spaces tailored to clients' needs, from concept to completion, while prioritizing sustainability, affordability, and timeless aesthetic appeal.</p>
                    <p className="aboutus-section-subheading">At BrickX, we offer a seamless home construction experience. Our team of expert construction professionals supports you at every stage, meticulously managing timelines, contractors, and budgets to ensure everything goes exactly according to plan.</p>
                    <p className="aboutus-section-subheading">We are committed to complete pricing transparency and offer customizable packages to fit your budget. Rest assured, there will be no unexpected costs. Secure payments can be made in installments at each stage of the home-building process.</p>
                </div>
            </section>

                        {/* Third Section */}
                        <div className="fifth-section">
                <h1 className="section-heading">Services for you</h1>
                <p className="section-subheading">Impeccable craftsmanship driven by extensive expertise.</p>
                <div className="box-container1">
                    <div className="our-services-box">
                        <div className="our-services-box-img">
                            <img src="/finalize/services/design-Build.png" className="box1-img" alt="" />
                        </div>
                        <h3 className="our-services-title">Design-Build</h3>
                        {/* <div className="bg-img">
                            <div className="our-services-content">
                                <h3 className="our-services-title">House  construction</h3>
                                <p className="our-services-subtitle">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Magni doloremque numquam fugit dicta possimus, architecto vitae ab, odio rem culpa eaque minima repellendus sit atque expedita nihil sed vero non.</p>
                            </div>
                        </div> */}
                    </div>
                    <div className="our-services-box">
                        <div className="our-services-box-img">
                            <img src="/finalize/services/project-management.png" className="box1-img" alt="" />
                        </div>
                        <h3 className="our-services-title">Project Management</h3>
                        {/* <div className="bg-img2">
                            <div className="our-services-content">
                                <h3 className="our-services-title">Construction for Bisiness</h3>
                                <p className="our-services-subtitle">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Magni doloremque numquam fugit dicta possimus, architecto vitae ab, odio rem culpa eaque minima repellendus sit atque expedita nihil sed vero non.</p>
                            </div>
                        </div> */}
                    </div>
                    <div className="our-services-box">
                        <div className="our-services-box-img">
                            <img src="/finalize/services/renovation_repairs.png" className="box1-img" alt="" />
                        </div>
                        <h3 className="our-services-title">Renovation and Remodeling</h3>
                        {/* <div className="bg-img3">
                            <div className="our-services-content">
                                <h3 className="our-services-title">Comprehensive Project Management</h3>
                                <p className="our-services-subtitle">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Magni doloremque numquam fugit dicta possimus, architecto vitae ab, odio rem culpa eaque minima repellendus sit atque expedita nihil sed vero non.</p>
                            </div>
                        </div> */}
                    </div>
                    <div className="our-services-box">
                        <div className="our-services-box-img">
                            <img src="/finalize/services/interior-design.png" className="box1-img" alt="" />
                        </div>
                        <h3 className="our-services-title">Interior Fit-Out</h3>
                        {/* <div className="bg-img3">
                            <div className="our-services-content">
                                <h3 className="our-services-title">Comprehensive Project Management</h3>
                                <p className="our-services-subtitle">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Magni doloremque numquam fugit dicta possimus, architecto vitae ab, odio rem culpa eaque minima repellendus sit atque expedita nihil sed vero non.</p>
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
            

            <Footer/>

        </>
    )
}
